import FolderPlus from '../../src/legacy/FolderPlus.tsx';
export default FolderPlus;
